import Palette from './shared/palette.js';
import typography from './shared/typography.js';
import brandColors from './shared/brandColors.js';
import { shadows, spacers, borderRadius, semanticColors } from './types.js';

/**
 * @deprecated Use lightBaseTheme instead.
 */
const darkBaseTheme = {
    name: 'dark',
    palette: Palette,
    shadows,
    spacers,
    borderRadius,
    typography,
    brandColors,
    colors: {
        ...semanticColors,
        Foreground: 'rgba(255, 255, 255, 1)',
        Background: 'rgba(34, 35, 41, 1)',
        ElementBackground: 'rgba(47, 48, 55, 1)',
        HoverBackground: 'rgba(90, 90, 94, 1)',
        BusinessBlue: 'rgba(10, 24, 73, 1)',
        'Level 1': 'rgba(255, 255, 255, 0.07)',
        'Level 2': 'rgba(255, 255, 255, 0.17)',
        'Level 3': 'rgba(255, 255, 255, 0.28)',
        'Level 4': 'rgba(255, 255, 255, 0.5)',
        'Level 5': 'rgba(255, 255, 255, 0.75)',
        Color1: Palette.torchRed[100],
        Color1_75: Palette.torchRed[75],
        Color1_50: Palette.torchRed[50],
        Color1_25: Palette.torchRed[25],
        Color1_15: Palette.torchRed[15],
        Color1_07: '#5F2836',
        Color2: Palette.electricBlue[100],
        Color2_75: Palette.electricBlue[75],
        Color2_50: Palette.electricBlue[50],
        Color2_25: Palette.electricBlue[25],
        Color2_15: Palette.electricBlue[15],
        Color2_07: '#2B2E3B',
        primary: Palette.torchRed[100],
        secondary: Palette.grey[15],
        positive: Palette.broccoli[100],
        caution: Palette.yolk[100],
        negative: Palette.tomato[100],
        primaryBackground: '#5F2836',
        secondaryBackground: Palette.grey[100],
        positiveBackground: '#31382D',
        cautionBackground: '#4F472E',
        negativeBackground: '#4A302C',
    },
};
var darkTheme = darkBaseTheme;

export { darkTheme as default };
